import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  /** Grid spacing in px. Default 24. */
  spacing?: number;
  /** Dot opacity 0–1. Default 0.35. */
  opacity?: number;
}

/**
 * SVG dotted-grid backdrop frame. Use to mark inset demos / mock content
 * (latest edition preview, topic picker preview).
 *
 * Renders an absolutely positioned background pattern behind children.
 */
const GridPaper = ({ children, className = "", spacing = 24, opacity = 0.35 }: Props) => {
  const id = `gp-${spacing}-${Math.round(opacity * 100)}`;
  return (
    <div className={`relative ${className}`}>
      <svg
        aria-hidden
        className="absolute inset-0 w-full h-full pointer-events-none text-border"
        style={{ opacity }}
      >
        <defs>
          <pattern id={id} x="0" y="0" width={spacing} height={spacing} patternUnits="userSpaceOnUse">
            <circle cx="1" cy="1" r="1" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${id})`} />
      </svg>
      <div className="relative">{children}</div>
    </div>
  );
};

export default GridPaper;
